import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints";

// Define a service using a base URL and expected endpoints
export const stateService = createApi({
  reducerPath: "stateService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["state"],
  endpoints: (builder) => ({
    getAllStates: builder.mutation({
      query: (body) => {
        return {
          url: `${userManagement.stateController.getAllStates}/${body.page}/${body.offset}?orderBy=${body.orderBy}`,
          method: "GET",
          // headers: { Authorization: `Bearer ${body.token}` },
          // body: body.payload,
        };
      },
    }),
    getAllStatesWithSearch: builder.mutation({
      query: (body) => {
        return {
          url: `${userManagement.stateController.getAllStatesWithSearch}`,
          method: "POST",
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    getState: builder.mutation({
      query: (body) => {
        return {
          url: `${userManagement.stateController.getState}/${body.countryId}`,
          method: "GET",
          // headers: { Authorization: `Bearer ${body.token}` },
          // body: body.payload,
        };
      },
    }),
    updateState: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.stateController.updateState}`,
          method: "PUT",
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    deleteState: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.stateController.deleteState}/${body.id}`,
          method: "DELETE",
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    getStateById: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.stateController.getStateById}/${body.id}`,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    saveState: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.stateController.saveState}`,
          method: "POST",
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllStatesMutation,
  useGetStateMutation,
  useDeleteStateMutation,
  useGetStateByIdMutation,
  useSaveStateMutation,
  useUpdateStateMutation,
  useGetAllStatesWithSearchMutation,
} = stateService;
